import React from "react";
import { Camera, Edit, Image, Trash2 } from "lucide-react";

const AvatarSection = ({
  avatarUrl,
  showAvatarMenu,
  onOpenMenu,
  onPickAvatar,
  onDeleteAvatar
}) => {
  return (
    <div className="avatar-section">
      <div className="avatar-container">
        <div className="avatar-placeholder">
          {avatarUrl ? (
            <img src={avatarUrl} alt="Avatar" className="avatar-image" />
          ) : (
            <svg className="avatar-silhouette" viewBox="0 0 128 128" aria-hidden="true">
              <circle cx="64" cy="64" r="64" className="av-bg" />
              <circle cx="64" cy="48" r="22" className="av-figure" fill="currentColor" />
              <path className="av-figure" d="M20 106c6-22 25-36 44-36s38 14 44 36" fill="currentColor" />
            </svg>
          )}
        </div>
        <button 
          className={`avatar-action-button ${avatarUrl ? 'has-avatar' : 'no-avatar'}`}
          type="button" 
          onClick={onOpenMenu}
          aria-label={avatarUrl ? "Edit avatar" : "Add avatar"}
        >
          {avatarUrl ? (
            <Edit className="avatar-action-icon" size={16} />
          ) : (
            <Camera className="avatar-action-icon" size={16} />
          )}
        </button>
        {showAvatarMenu && (
          <div className="avatar-menu" onClick={(e) => e.stopPropagation()}>
            <input 
              id="avatar-input-edit" 
              type="file" 
              accept="image/*" 
              onChange={onPickAvatar} 
              className="hidden-input" 
            />
            <button 
              type="button" 
              className="avatar-menu-item"
              onClick={() => document.getElementById('avatar-input-edit')?.click()}
            >
              <Image className="menu-item-icon" size={16} />
              <span>Choose from library</span>
            </button>
            {avatarUrl && (
              <button 
                type="button" 
                className="avatar-menu-item delete"
                onClick={onDeleteAvatar}
              >
                <Trash2 className="menu-item-icon" size={16} />
                <span>Delete</span>
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AvatarSection;

